import type { IOrder } from '@/types/IOrder'

export const initialValues = (data: Partial<IOrder> | undefined) => {
  if (data) {
    return {
      ...data,
      customer: data?.customer?.uuid,
      opportunity: data?.opportunity?.uuid,
      device: data?.device?.uuid,
      company: data?.device?.company?.uuid
    }
  }
  return {}
}

